import { TMCClientParameters } from '@sdbn/tmc-common';
import { TranslationService } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { AppClientConfigurationService } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class TransportFormatterService {

  constructor(
    private translationService: TranslationService,
    private configurationService: AppClientConfigurationService) {

  }

  public formatTransportIdentifier(identifier: string, transportScope: any): string {

    if (this.configurationService.isPropertyTrue(TMCClientParameters.P_VISITS_ATTACH_DETACH_ENABLED, false)) {
      const i18n = this.translationService.translate('tmc-yard.ui.transport-formatter.transport-scope.' + transportScope);
      if (i18n) {
        return i18n + ' - ' + identifier;
      }
    }

    return identifier;
  }

}
